// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs-module__tabs__OumPs","content":"Tabs-module__content__k9pWk","chevron":"Tabs-module__chevron__BqzFl","icon":"Tabs-module__icon__OC6W4"};